import React from "react";
import "./about-us.css";
import { useTranslation } from "react-i18next";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import BannerComponent from "../../components/bannerComponent/bannerComponent";
import ButtonLinkComponent from "../../components/buttonLink/buttonLink.jsx";

const About_Us = () => {
  const { t } = useTranslation();
  const [selectedMember, setSelectedMember] = React.useState(null);

  React.useEffect(() => {
    console.log("Fabian Urrutia");
  }, []);

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=ABOUT_US";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("GET_TO_KNOW"),
    text: t("ABOUT_US_HERO_SUB"),
    className: "aboutHeroBanner",
    chipText: t("ABOUT_US"),
  };

  const companyInfoArray = [
    {
      title: t("ABOUT_US_MISSION"),
      description: t("ABOUT_US_MISSION_DESCRIPTION"),
      image: "/img/mission 2 2.jpg",
    },
    {
      title: t("ABOUT_US_VISION"),
      description: t("ABOUT_US_VISION_DESCRIPTION"),
      image: "/img/mission 2 1.jpg",
    },
  ];

  const companyValuesArray = [
    t("ABOUT_US_INNOVATION"),
    t("ABOUT_US_EXCELLENCE"),
    t("ABOUT_US_COMMITMENT"),
    t("ABOUT_US_RESPONSIBILITY"),
    t("ABOUT_US_COLLABORATION"),
    t("ABOUT_US_ADAPTABILITY"),
    t("ABOUT_US_INTEGRITY"),
    t("ABOUT_US_AUTONOMY"),
    t("ABOUT_US_COMMUNICATION"),
    t("ABOUT_US_IMPROVEMENT"),
  ];

  const teamMembers = [
    {
      id: "lorena",
      image: "/img/Lorena Cordoba 1.png",
      name: t("ABOUT_US_LORENA_NAME"),
      position: t("ABOUT_US_LORENA_POSITION"),
      description: `${t("ABOUT_US_LORENA_DESCRIPTION_1")} ${t("ABOUT_US_LORENA_DESCRIPTION_2")}`,
    },
    {
      id: "dhru",
      image: "/img/Dhruval Shah 1.png",
      name: t("ABOUT_US_DHRU_NAME"),
      position: t("ABOUT_US_DHRU_POSITION"),
      description: `${t("ABOUT_US_DHRU_DESCRIPTION_1")} ${t("ABOUT_US_DHRU_DESCRIPTION_2")}`,
    },
    {
      id: "julian",
      image: "/img/Julian Huertas 1.png",
      name: t("ABOUT_US_JULIAN_NAME"),
      position: t("ABOUT_US_JULIAN_POSITION"),
      description: `${t("ABOUT_US_JULIAN_DESCRIPTION_1")} ${t("ABOUT_US_JULIAN_DESCRIPTION_2")}`,
    },
    {
      id: "sara",
      image: "/img/Sara Mendoza 1.png",
      name: t("ABOUT_US_SARA_NAME"),
      position: t("ABOUT_US_SARA_POSITION"),
      description: `${t("ABOUT_US_SARA_DESCRIPTION_1")} ${t("ABOUT_US_SARA_DESCRIPTION_2")}`,
    },
    {
      id: "carlos",
      image: "/img/Carlos Quintero 1.png",
      name: t("ABOUT_US_CARLOS_NAME"),
      position: t("ABOUT_US_CARLOS_POSITION"),
      description: `${t("ABOUT_US_CARLOS_DESCRIPTION_1")} ${t("ABOUT_US_CARLOS_DESCRIPTION_2")}`,
    },
    {
      id: "paula",
      image: "/img/Paula Carillo 1.png",
      imagePosition: "center 15%",
      name: t("ABOUT_US_PAULA_NAME"),
      position: t("ABOUT_US_PAULA_POSITION"),
      description: `${t("ABOUT_US_PAULA_DESCRIPTION_1")} ${t("ABOUT_US_PAULA_DESCRIPTION_2")}`,
    },
    {
      id: "jorge",
      image: "/img/Jorge Ramos 1.png",
      name: t("ABOUT_US_JORGE_NAME"),
      position: t("ABOUT_US_JORGE_POSITION"),
      description: `${t("ABOUT_US_JORGE_DESCRIPTION_1")} ${t("ABOUT_US_JORGE_DESCRIPTION_2")}`,
    },
  ];

  function InfoCard({ title, text, image }) {
    return (
        <article className="aboutInfoCard">
        <div className="aboutInfoMedia">
            <img src={image} alt={title} />
        </div>

        <div className="aboutInfoContent">
            <span className="aboutInfoEyebrow">{title}</span>
            <h3>{title}</h3>
            <p>{text}</p>
        </div>
        </article>
    );
    }

    function TeamCard({ member }) {
        return (
            <article className="aboutTeamCard">
            <div className="aboutTeamTopGlow"></div>

            <div className="aboutTeamImageWrap">
                <img
                src={member.image}
                alt={member.name}
                style={member.imagePosition ? { objectPosition: member.imagePosition } : undefined}
                />
            </div>

            <div className="aboutTeamContent">
                <h3>{member.name}</h3>
                <p className="aboutTeamRole">{member.position}</p>
                <p className="aboutTeamDescription">
                {member.description}
                </p>

                <button
                type="button"
                className="aboutTeamMoreBtn"
                onClick={() => setSelectedMember(member)}
                >
                {t("ABOUT_US_READ_MORE")}
                </button>
            </div>
            </article>
        );
    }

    function TeamModal({ member, onClose }) {
        if (!member) return null;

        return (
            <div className="aboutTeamModalOverlay" onClick={onClose}>
            <div
                className="aboutTeamModal"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                type="button"
                className="aboutTeamModalClose"
                onClick={onClose}
                aria-label={t("ABOUT_US_CLOSE")}
                >
                ×
                </button>

                <div className="aboutTeamModalGrid">
                <div className="aboutTeamModalMedia">
                    <img
                    src={member.image}
                    alt={member.name}
                    style={member.imagePosition ? { objectPosition: member.imagePosition } : undefined}
                    />
                </div>

                <div className="aboutTeamModalContent">
                    <span className="aboutTeamModalChip">{t("ABOUT_US")}</span>
                    <h3>{member.name}</h3>
                    <p className="aboutTeamModalRole">{member.position}</p>
                    <p className="aboutTeamModalDescription">{member.description}</p>
                </div>
                </div>
            </div>
            </div>
        );
    }

  return (
    <>
      <Header />

      <main className="aboutPage">
        <section className="aboutHero aboutHeroFull">
          <div className="aboutHeroBannerFull">
            <BannerComponent
              translateTitle={heroData.title}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("MORE_SERVICE_ERP_CTA")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="aboutIntro">
          <div className="aboutSectionIntro">
            <h2>{t("ABOUT_US")}</h2>
            <p>{t("ABOUT_US_DESCRIPTION")}</p>
          </div>
        </section>

        <section className="aboutMissionVision">
          <div className="aboutBlockWrap">
            <div className="aboutInfoGrid">
              {companyInfoArray.map((item, index) => (
                <InfoCard
                  key={index}
                  title={item.title}
                  text={item.description}
                  image={item.image}
                  reverse={index % 2 === 1}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="aboutResponsibility">
          <div className="aboutBlockWrap">
            <div className="aboutSectionIntro">
              <h2>{t("ABOUT_US_SOCIAL_RESPONSIBILITY")}</h2>
            </div>

            <div className="aboutResponsibilityGrid">
              <div className="aboutResponsibilityMedia">
                <img
                  src="/img/cyber-security-experts-working-with-tech-devices-neon-lights 1.jpg"
                  alt={t("ABOUT_US_SOCIAL_RESPONSIBILITY")}
                />
              </div>

              <div className="aboutResponsibilityContent">
                <p>{t("ABOUT_US_SOCIAL_RESPONSIBILITY_PART1")}</p>
                <p>{t("ABOUT_US_SOCIAL_RESPONSIBILITY_PART2")}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="aboutValues">
          <div className="aboutBlockWrap">
            <div className="aboutSectionIntro">
              <h2>{t("ABOUT_US_OUR_VALUES")}</h2>
            </div>

            <div className="aboutValuesGrid">
              {companyValuesArray.map((value, index) => (
                <div className="aboutValueCard" key={index}>
                  <span>•</span>
                  <p>{value}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="aboutTeam">
          <div className="aboutSectionIntro">
            <h2>{t("ABOUT_US_MEET_OUR_TEAM")}</h2>
            <p>{t("ABOUT_US_TEAM_DESCRIPTION")}</p>
          </div>

          <div className="aboutTeamGrid">
                {teamMembers.map((member) => (
                    <TeamCard key={member.id} member={member} />
                ))}
            </div>

            <TeamModal
                member={selectedMember}
                onClose={() => setSelectedMember(null)}
            />
        </section>

        <section className="aboutCta">
          <div className="aboutCtaInner">
            <div className="aboutCtaContent">
              <h2>{t("ABOUT_US_CTA_TITLE")}</h2>
              <p>{t("ABOUT_US_CTA_DESC")}</p>
            </div>

            <ButtonLinkComponent
              translateButton={t("MORE_SERVICE_ERP_CTA")}
              url="https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=ABOUT_US"
              blank={true}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default About_Us;